export const playout = {
  welcomeGoLive: 'welcome-header-goLive',
  welcomeControl: 'welcome-header-control',
  welcomeWhatsNew: 'welcome-header-whatsNew',
  welcomeHeaderRecording: 'welcome-header-recording',
  welcomeSignIn: 'welcome-header-signIn',
  welcomeTvuServiceList: 'welcome-header-tvuServiceList',
  welcomeAddOutPut: 'welcome-header-addOutputAccount',

  welcomeSelectLiveSourceTab: 'welcome-LiveSourceTab-selected',
  welcomeSelectMediaTab: 'welcome-MediaTab-selected',
  welcomeSelectProgramTemplateTab: 'welcome-ProgramTemplateTab-selected',
  welcomeSelectScheduleTemplateTab: 'welcome-ScheduleTemplateTab-selected',
  welcomeMediaSearch: 'welcome-Media-search',
  welcomeMediaAddFolder: 'welcome-Media-addFolder',
  welcomeMediaAddVideo: 'welcome-Media-addVideo',
  welcomeMediaEditFolder: 'welcome-Media-editFolder',
  welcomeMediaDeleteFolder: 'welcome-Media-deleteFolder',
  welcomeMediaEditFile: 'welcome-Media-editFile',
  welcomeMediaDeleteFile: 'welcome-Media-deleteFile',
  welcomeLiveSourceSearch: 'welcome-LiveSource-search',
  welcomeLiveSourceSelectedSource: 'welcome-LiveSource-selectedSource',
  welcomeTemplateSearch: 'welcome-Template-search',
  welcomeTemplateAdd: 'welcome-Template-add',
  welcomeScheduleSearch: 'welcome-Schedule-search',
  welcomeScheduleAdd: 'welcome-Schedule-add',
  welcomeCrawlClick: 'welcome-CrawlBtn-click',
  welcomeDuplicateClick: 'welcome-Duplicate-click',
  welcomeDuplicateDialogSave: 'welcome-DuplicateDialog-save',
  // welcomeDayClick: 'welcome-View-click',
  welcomeEventClick: 'welcome-Event-click',
  welcomeViewBlankClick: 'welcome-ViewBlank-click',
  welcomeViewSwitch: 'welcome-View-switch'

}
